var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-home",staticStyle:{"padding":"0 15px"}},[_c('router-link',{staticClass:"f messages",staticStyle:{"color":"black"},attrs:{"to":"/web-index"}},[_c('span',{staticClass:"icon font_family icon-dibutubiao_shouye",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("商城首页")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-d4b5df1c","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/MallHome/index.vue
// module id = 1319
// module chunks = 72